<template>
  <div class="orderinfo">
    <h1>購物指南</h1>
    <div class="orderinfo__container">
      <div class="orderinfo__collapse"
      v-for="(item, index) in orderInfos"
      :key="index">
        <!-- Using value -->
        <b-button v-b-toggle="`collapse-${index}`" v-html="item.title"
        class="orderinfo__collapse__header">
        </b-button>
        <!-- Element to collapse -->
        <b-collapse :id="`collapse-${index}`">
          <div class="orderinfo__collapse__body"
           v-html="item.content"
          ></div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    orderInfos() {
      let resultArr = [];
      this.$bus.$on('son_get_data', (data) => {
        resultArr = data.orderInfos;
      });
      this.$bus.$emit('son_call_data');
      return resultArr;
    },
  },
};
</script>
